import { render, staticRenderFns } from "./SearchModule.vue?vue&type=template&id=8634eecc&scoped=true"
import script from "./SearchModule.vue?vue&type=script&lang=js"
export * from "./SearchModule.vue?vue&type=script&lang=js"
import style0 from "./SearchModule.vue?vue&type=style&index=0&id=8634eecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8634eecc",
  null
  
)

export default component.exports